import { HelpCircle } from "lucide-react";
import { Link, useRouterState } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";

interface ContextualHelpButtonProps {
    moduleKey?: string;
    title?: string;
}

function resolveModuleKeyFromPathname(pathname: string): string {
    const clean = pathname.replace(/^\/+|\/+$/g, "");
    if (!clean) return "overview";
    const parts = clean.split("/");
    // Match specific multi-segment routes first
    if (clean.startsWith("planning/paper-allocation")) return "paper-allocation";
    if (clean.startsWith("warehouse/fg/stocktakes") || clean.startsWith("warehouse/stocktake")) return "stocktakes";
    if (clean.startsWith("warehouse/fg/stock-card") || clean.startsWith("warehouse/inventory-nxt")) return "inventory-nxt";
    if (clean.startsWith("warehouse/fg")) return "fg-inventory";
    if (clean.startsWith("warehouse/material/transactions")) return "transactions";
    if (clean.startsWith("factory/production-logs")) return "production-logs";
    if (clean.startsWith("factory/machine-logs")) return "machine-logs";
    if (clean.startsWith("shopfloor/terminal") || clean.startsWith("mes/touch-terminal")) return "shopfloor";
    if (clean.startsWith("finance/receipts")) return "receipts";
    if (clean.startsWith("finance/reconciliations")) return "reconciliations";
    if (clean.startsWith("purchasing/debts")) return "debts";
    if (clean.startsWith("system/audit-logs")) return "audit-logs";
    if (clean.startsWith("reports/sales")) return "reports-sales";
    return parts[0] || "overview";
}

export function ContextualHelpButton({
    moduleKey,
    title = "Xem cẩm nang hướng dẫn sử dụng màn hình này",
}: ContextualHelpButtonProps) {
    const pathname = useRouterState({ select: (s) => s.location.pathname });
    const resolvedKey = moduleKey || resolveModuleKeyFromPathname(pathname);

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        data-testid="contextual-help-btn"
                        className="h-7 w-7 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 shrink-0"
                        asChild
                    >
                        <Link to="/guide" search={{ module: resolvedKey }}>
                            <HelpCircle className="h-4 w-4" />
                        </Link>
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{title}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}

